<template>
  <span>
    {{ format() }}
  </span>
</template>

<script>
export default {
  props: {
    value: {
      type: String | undefined | null,
      default: '',
      required: true,
    },
    /**
     * Tipo de formatação para Data
     * @default "DD/MM/YYYY"
     * @type {"DD/MM/YYYY" | "DD/MM" | "DD" | "ABBREVIATEDMONTH/YYYY"}
     */
    formatType: {
      type: String,
      default: 'DD/MM/YYYY',
      required: false,
    },
  },
  methods: {
    format() {
      const dateValue = this.value;
      if (!dateValue) return '';
      const date = new Date(dateValue);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const abbreviatedMonth = new Intl.DateTimeFormat('pt-BR', {
        month: 'short',
      })
        .format(date)
        .toUpperCase()
        .substring(0, 3);

      switch (this.formatType) {
        case 'DD/MM/YYYY': {
          return `${day
            .toString()
            .padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
        }
        case 'DD/MM': {
          return `${day
            .toString()
            .padStart(2, '0')}/${month.toString().padStart(2, '0')}`;
        }
        case 'DD': {
          return `${day.toString().padStart(2, '0')}`;
        }
        case 'ABBREVIATEDMONTH/YYYY': {
          return `${abbreviatedMonth}/${year}`;
        }
        default: {
          return date;
        }
      }
    },
  },
};
</script>
